import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNewspaper1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="newspaper-1, guide, info, faq, book"><path d="M12 7V20M2.75 4.25L12 6.3125L21.25 4.25V18.6875L12 20.75L2.75 18.6875V4.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
};

export default IconNewspaper1;
